// import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const caseStudies = [
  {
    title: "Cloud Migration Success Story",
    company: "Global Retail Corp",
    challenge: "Facing scalability issues and high operational costs with their on-premises infrastructure.",
    solution: "Implemented a comprehensive cloud migration strategy using AWS, resulting in improved performance and reduced costs.",
    results: [
      "40% reduction in operational costs",
      "99.9% system uptime",
      "50% faster deployment times",
      "Improved scalability and flexibility"
    ],
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=600&q=80",
    category: "Cloud Computing",
    link: "/case-studies/cloud-migration"
  },
  {
    title: "AI-Powered Customer Service",
    company: "Tech Solutions Inc",
    challenge: "Overwhelmed customer service team struggling with response times and customer satisfaction.",
    solution: "Developed and implemented an AI-powered chatbot system integrated with existing customer service platforms.",
    results: [
      "60% reduction in response time",
      "85% customer satisfaction rate",
      "24/7 automated support",
      "30% cost savings in customer service"
    ],
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=600&q=80",
    category: "AI & Automation",
    link: "/case-studies/ai-customer-service"
  },
  {
    title: "DevOps Transformation",
    company: "Financial Services Ltd",
    challenge: "Slow deployment cycles and frequent production issues affecting business operations.",
    solution: "Implemented end-to-end DevOps practices with automated CI/CD pipelines and monitoring.",
    results: [
      "75% faster deployment cycles",
      "90% reduction in production incidents",
      "Improved team collaboration",
      "Enhanced code quality"
    ],
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=600&q=80",
    category: "DevOps",
    link: "/case-studies/devops-transformation"
  }
];

export const CaseStudiesSection = () => {
  return (
    <section className="py-20 px-6 bg-gray-900 dark:bg-gray-950">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Success Stories</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Discover how we&apos;ve helped organizations transform their operations and achieve remarkable results.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {caseStudies.map((study, index) => (
            <motion.div
              key={index}
              className="bg-gray-800 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              <div className="relative">
                <img
                  src={study.image}
                  alt={study.title}
                  className="w-full h-48 object-cover"
                />
                <span className="absolute top-4 left-4 bg-blue-500 text-white px-3 py-1 rounded-full text-sm">
                  {study.category}
                </span>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-white mb-2">{study.title}</h3>
                <p className="text-blue-400 mb-4">{study.company}</p>
                
                <div className="mb-4">
                  <h4 className="text-gray-300 font-medium mb-2">Challenge</h4>
                  <p className="text-gray-400 text-sm">{study.challenge}</p>
                </div>
                
                <div className="mb-4">
                  <h4 className="text-gray-300 font-medium mb-2">Solution</h4>
                  <p className="text-gray-400 text-sm">{study.solution}</p>
                </div>
                
                <div className="mb-6">
                  <h4 className="text-gray-300 font-medium mb-2">Results</h4>
                  <ul className="space-y-2">
                    {study.results.map((result, i) => (
                      <li key={i} className="flex items-center text-gray-400 text-sm">
                        <svg className="w-4 h-4 mr-2 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        {result}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <Link to={study.link}>
                  <motion.button
                    className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg font-medium transition-colors"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    Read Full Case Study
                  </motion.button>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
        <div className="text-center mt-12">
          <motion.button
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-medium transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            View All Case Studies
          </motion.button>
        </div>
      </div>
    </section>
  );
}; 